import { createReducer } from "@reduxjs/toolkit";
import {
    USER_UPDATE,
    USER_UPDATE_TELEPHONE,
    USER_UPDATE_EMAIL,
    USER_ERROR,
    AUTH_UPDATE
} from "./authentication-actions";

export const defaultState = {
    user: {
        username: "",
        email: {
            address: "",
            verification: ""
        },
        firstname: "",
        telephone: {
            phoneNumber: "",
            countryCode: "",
            international: "",
            verification: ""
        }
    },
    auth: {},
    error: ""
};

const authenticationReducer = createReducer(defaultState, (builder) =>
    builder
        .addCase(USER_UPDATE, (state, { payload }) => {
            state.user = {
                ...state.user,
                ...payload.user
            };
            state.error = "";
        })
        .addCase(USER_UPDATE_TELEPHONE, (state, { payload }) => {
            state.user = {
                ...state.user,
                telephone: {
                    ...state.user.telephone,
                    ...payload.telephone
                }
            };
            state.error = "";
        })
        .addCase(USER_UPDATE_EMAIL, (state, { payload }) => {
            state.user = {
                ...state.user,
                email: {
                    ...state.user.email,
                    ...payload.email
                }
            };
            state.error = "";
        })
        .addCase(USER_ERROR, (state, { payload }) => {
            state.error = payload.error;
        })
        .addCase(AUTH_UPDATE, (state, { payload }) => {
            state.user = {
                ...state.user,
                ...(payload.user || {})
            };
            state.auth = {
                ...state.auth,
                ...payload.auth
            }
            state.error = "";
        })
);

export default authenticationReducer;
